import {EnvEventPostDataTransferObject} from "../../data-transfer-object/env/EnvEventPostDataTransferObject"

/**
 * 이벤트 속성 설명
 */
export const EnvEventPostDataTransferObjectDescription: Record<keyof EnvEventPostDataTransferObject, string> = {
    title: '제목',
    url: 'URL'
}
